export const CAMPAIGN_STATUS = Object.freeze({
    ONGOING: "ongoing",
    NOT_STARTED: "not_started",
    COMPLETED: "completed"
});

export const COUNTRY_CODES = Object.freeze({
    SWEDEN: "se",
    NORWAY: "no",
    DENMARK: "dk"
});

export const PRODUCT_TYPES = Object.freeze({
    PLAY: "play",
    CLASSIC: "posting"
});

export const FOLLOW_UP_TYPES = Object.freeze({
    PLAYS: "plays",
    CONTACTS: "contacts",
    SCREENS: "screens",
    PLAYS: "plays"
})

export const CLASSIC_PANEL_STATUS = Object.freeze({
    POSTED: "posted",
    FAILED: "failed",
    PARTIALLY: "partially",
    ONGOING: "ongoing",
    NOT_STARTED: "not started",
    LATE: "late",
    POSTED_LATE: "posted late",
    EARLY: "early"
})

export const CAMPAING_PROMISE_TYPES = Object.freeze({
    SFI: "sfi",
    VAC: "vac",
    SOV: "sov",
    SOVP: "sovp",
    SOVD: "sovd",
    FXP: "fxp",
    FXA: "fxa",
    FXI: "fxi",
    FLEXAI: "flexai",
    PLAY: "play",
    SE_CLASSIC_EAVAC: "scev",
    SE_DIGITAL_VAC : "sdv",
    SE_DIGITAL_EAVAC: "sdev",
    SE_DIGITAL_SOV: "sds",
    SE_CLASSIC_PANELS_OI: "scpo", 
    SE_CLASSIC_PANELS: "scp",
    SE_CLASSIC_PANELS_FILLER: "scpf",
    SE_DIGITAL_PLAYS: "sdp",
    SE_DIGITAL_EAVAC_FILLER: "sdef",
    SE_DIGITAL_NO_PROMISE: "sd",
    SE_CLASSIC_VAC: "scv",
    SE_CLASSIC_PANELS_EAVAC_OI: "scpeo",

    NO_CLASSIC_PANELS: "ncp",
    NO_CLASSIC_PANELS_FILLER: "ncpf",
    NO_PLAY_VAC: "npv",
	NO_PLAY_VAC_FILLER: "npvf",
	NO_PLAY_PLAYS: "npp",
    NO_CLASSIC_VAC_2_0: "nsv",
    NO_CLASSIC_PANELS_2_0: "nsp",
    NO_CLASSIC_PANELS_VAC_2_0: "nspv",
    NO_CLASSIC_VAC_FILLER_2_0: "nsvf",
    NO_PLAY_VAC_2_0: "npv2",
    NO_PLAY_VAC_FILLER_2_0: "npvf2",
    NO_PLAY_PLAYS_2_0: "npp2",
    NO_PLAY_SOV_2_0: "nps",
    NO_AIRPORT_PLAYS_2_0_1: "npp21",

    DK_PLAY_VAC_PANELS: "dpvp",
    DK_PLAY_VAC: "dpv",
    DK_PLAY_PLAYS: "dpp",
    DK_CLASSIC_PANELS: "dcp",
    DK_AIRPORT_VAC_PANELS: "davp",
    DK_AIRPORT_VAC: "dav",
    DK_PLAY_VAC_PANELS_2_0: "dpvp2",
    DK_PLAY_VAC_2_0: "dpv2",
    DK_PLAY_PLAYS_2_0: "dpp2",
    DK_AIRPORT_VAC_PANELS_2_0: "davp2",
    DK_AIRPORT_VAC_2_0: "dav2",
    DK_CLASSIC_PANELS_2_0: "dcp2",
    DK_CLASSIC_PANELS_ADSHEL_2_0: "dcap2",
    DK_DIGITAL_SOV: "dsov",
    DK_CLASSIC_PANELS_METRO_NON_MOMS: "dos"
})

export const CREATIVE_MIMES = Object.freeze({
    MP4: "mp4",
    MOV: "mov",
    JPG: "jpg",
    JPEG: "jpeg",
    PNG: "png",
    GIF: "gif",
    WEBP: "webp",
    ZIP: "zip",
    PDF: "pdf"
})

export const AD_TYPES = Object.freeze({
    VIDEO: "video",
    IMAGE: "image",
    PDF: "pdf"
})

export const PANEL_TYPES = Object.freeze({
    ADSHEL_CLASSIC: "adshel",
    ADSHEL_PLAY: "adshel",
    BILLBOARD_PLAY: "billboard",
    SPECTACULAR_PORTRAIT_PLAY: "spectacular_portrait",
    STORM_PLAY: "storm",
    ESCALATOR_CLASSIC: "escalator",
    THREE_GROUP_CLASSIC: "threegroup"
})

export const INFOBOX_DISPLAY_TYPE = Object.freeze({
    TARGET: "target",
    DELIVERED: "delivered",
    BOTH: "both",
})

export const VISIBLE_FIELDS = Object.freeze({
    AUDIENCE: "Audience",
    ALT_AUDIENCE: "AltAudience",
    PANELS: "Panels",
    PLAYS: "Plays",
    SOV: "Sov",
    SPOT_LENGTH: "SpotLength",
    PANELS_SOV: "PanelsSov",
})

export const FIELD_DISPLAY_TYPES = Object.freeze({
    ESTIMATED: "Estimated",
    DELIVERED: "Delivered",
})

export const CAMPAIGN_PROMISE_EXTRA_TEXT_TYPES = Object.freeze({
    DETAILS_TAB: 'details_tab',
    ADDRESS_LIST_TAB: 'address_list_tab',
    SUMMARY_TAB: 'summary_tab',
    OVERVIEW_DETAILS: 'overview_details'
});

export const CAMPAIGN_PROMISE_EXTRA_TEXTS = Object.freeze({
    // Swedish promise texts
    SE_IDS_CLASSIC_GROUP: {
        types: [CAMPAING_PROMISE_TYPES.SE_CLASSIC_VAC],
        textType: CAMPAIGN_PROMISE_EXTRA_TEXT_TYPES.OVERVIEW_DETAILS,
        text: '* For posting details, see Details and Address list tabs'
    },
    SE_DIGITAL_SOV_GROUP: {
        types: [
            CAMPAING_PROMISE_TYPES.SE_DIGITAL_SOV,
            CAMPAING_PROMISE_TYPES.SE_DIGITAL_EAVAC_FILLER,
            CAMPAING_PROMISE_TYPES.SE_DIGITAL_EAVAC,
            CAMPAING_PROMISE_TYPES.SE_DIGITAL_NO_PROMISE,
        ],
        textType: CAMPAIGN_PROMISE_EXTRA_TEXT_TYPES.DETAILS_TAB,
        text: '* EA-VAC calculated based on a 5 sec spot length and for an average week.'
    },

    SE_CLASSIC_EAVAC: {
        types: [CAMPAING_PROMISE_TYPES.SE_CLASSIC_EAVAC],
        textType: CAMPAIGN_PROMISE_EXTRA_TEXT_TYPES.ADDRESS_LIST_TAB,
        text: 'Please note that the address list is prelimary until 5 working days before campaign start'
    },

    SE_CLASSIC_PANELS_GROUP: {
        types: [
            CAMPAING_PROMISE_TYPES.SE_CLASSIC_PANELS_OI,
            CAMPAING_PROMISE_TYPES.SE_CLASSIC_PANELS,
            CAMPAING_PROMISE_TYPES.SE_CLASSIC_PANELS_FILLER
        ],
        textType: CAMPAIGN_PROMISE_EXTRA_TEXT_TYPES.ADDRESS_LIST_TAB,
        text: 'Please note that the address list is prelimary until 5 working days before campaign start'
    },

    SE_CLASSIC_POSTING: {
        types: [
            CAMPAING_PROMISE_TYPES.SE_CLASSIC_EAVAC,
            CAMPAING_PROMISE_TYPES.SE_CLASSIC_PANELS_OI,
            CAMPAING_PROMISE_TYPES.SE_CLASSIC_PANELS,
            CAMPAING_PROMISE_TYPES.SE_CLASSIC_PANELS_EAVAC_OI
        ],
        textType: CAMPAIGN_PROMISE_EXTRA_TEXT_TYPES.DETAILS_TAB,
        text: 'Posting is conducted from Sunday 18:00 to Tuesday 23:59<br><br>Bauer Media Outdoor guarantees 97 % delivery according to our <a href="https://www.bauermediaoutdoor.se/legal/">terms and conditions.</a>'
    },

    // Norwegian promise texts
    NO_PLAY_GROUP: {
        types: [
            CAMPAING_PROMISE_TYPES.NO_PLAY_VAC,
            CAMPAING_PROMISE_TYPES.NO_PLAY_VAC_FILLER
        ],
        textType: CAMPAIGN_PROMISE_EXTRA_TEXT_TYPES.DETAILS_TAB,
        text: '* VAC figures based on a 10 second spot length and referencing March month data'
    },

    NO_PLAY_VAC_VI_GROUP: {
        types: [
            CAMPAING_PROMISE_TYPES.NO_PLAY_VAC_2_0,
            CAMPAING_PROMISE_TYPES.NO_PLAY_SOV_2_0,
            CAMPAING_PROMISE_TYPES.NO_PLAY_VAC_FILLER_2_0
        ],
        textType: CAMPAIGN_PROMISE_EXTRA_TEXT_TYPES.DETAILS_TAB,
        text: '* VAC/VI figures based on a 10 second spot length'
    },

    NO_CLASSIC_PANELS_GROUP: {
        types: [
            CAMPAING_PROMISE_TYPES.NO_CLASSIC_PANELS,
            CAMPAING_PROMISE_TYPES.NO_CLASSIC_PANELS_FILLER,
            CAMPAING_PROMISE_TYPES.NO_CLASSIC_VAC_2_0,
            CAMPAING_PROMISE_TYPES.NO_CLASSIC_PANELS_VAC_2_0,
            CAMPAING_PROMISE_TYPES.NO_CLASSIC_VAC_FILLER_2_0
        ],
        textType: CAMPAIGN_PROMISE_EXTRA_TEXT_TYPES.DETAILS_TAB,
        text: 'Posting is conducted from Sunday 18:00 to Tuesday 23:59<br><br>Bauer Media Outdoor guarantees 95 % delivery according to our standard <a href="https://www.bauermediaoutdoor.no/legal/generelle-salgsbetingelser/">Terms of Purchase of Goods.</a>'
    },    

    // Danish promise texts
    DK_PLAY_GROUP: {
        types: [
            CAMPAING_PROMISE_TYPES.DK_PLAY_VAC_PANELS,
            CAMPAING_PROMISE_TYPES.DK_PLAY_VAC,
            CAMPAING_PROMISE_TYPES.DK_PLAY_PLAYS,
            CAMPAING_PROMISE_TYPES.DK_AIRPORT_VAC_PANELS,
            CAMPAING_PROMISE_TYPES.DK_AIRPORT_VAC,
            CAMPAING_PROMISE_TYPES.DK_PLAY_VAC_PANELS_2_0,
            CAMPAING_PROMISE_TYPES.DK_PLAY_VAC_2_0,
            CAMPAING_PROMISE_TYPES.DK_PLAY_PLAYS_2_0,
            CAMPAING_PROMISE_TYPES.DK_AIRPORT_VAC_PANELS_2_0,
            CAMPAING_PROMISE_TYPES.DK_AIRPORT_VAC_2_0            
        ],
        textType: CAMPAIGN_PROMISE_EXTRA_TEXT_TYPES.SUMMARY_TAB,
        text: 'Terms & Conditions and Cookie Policy The general terms and conditions document at <a href="https://www.bauermediaoutdoor.dk/legal/forretningsbetingelser-ovrige-vilkar/">Business Terms & Conditions.</a>',
    },

    DK_CLASSIC_PANELS: {
        types: [CAMPAING_PROMISE_TYPES.DK_CLASSIC_PANELS,
            CAMPAING_PROMISE_TYPES.DK_CLASSIC_PANELS_2_0,
            CAMPAING_PROMISE_TYPES.DK_CLASSIC_PANELS_ADSHEL_2_0
        ],
        textType: CAMPAIGN_PROMISE_EXTRA_TEXT_TYPES.DETAILS_TAB,
        text: 'Posting is conducted from Sunday 18:00 to Tuesday 23:59<br><br>Bauer Media Outdoor guarantees 95 % delivery according to our <a href="https://www.bauermediaoutdoor.dk/legal/forretningsbetingelser-ovrige-vilkar/">Business Terms & Conditions.</a>'
    }
})